export default {
    get(name) {
        try {
            let data = localStorage.getItem(name)
            data = JSON.parse(data)
            return data
        } catch (e) { }
    },
    set(name, value) {
        localStorage.setItem(name, JSON.stringify(value))
    },
    del(name) {
        localStorage.removeItem(name)
    }
}